module.exports = __webpack_public_path__ + "static/media/Picture-Library.0daf3ce7.png";